<div class="add-container">
	<h1 class="add-title">Adaugă un grup de modul</h1>
	<form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
		<div class="add-field">
			<div class="spinner">
				<mat-spinner color="primary" *ngIf="isPartLoading"></mat-spinner>
			</div>
			<mat-form-field *ngIf="!isPartLoading" appearance="fill">
				<mat-label>Grup Parinte</mat-label>
				<mat-select formControlName="parent_id">
					<mat-option *ngFor="let row of moduleGroupsNoParent$ | async" [value]="row.id">
						{{ row.name }}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="!form.controls['parent_id'].valid && form.controls['parent_id'].touched">
					Câmp obligatoriu
				</mat-error>
			</mat-form-field>
		</div>

		<div class="row">
			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Denumire grup</mat-label>
					<input type="text" matInput formControlName="name" />
					<mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Slug</mat-label>
					<input type="text" matInput formControlName="slug" />
					<mat-error *ngIf="!form.controls['slug'].valid && form.controls['slug'].touched">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Observatii</mat-label>
					<input type="text" matInput formControlName="observations" />
					<mat-error *ngIf="
						!form.controls['observations'].valid &&
						form.controls['observations'].touched
					">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		
		<div class="row">
			<div class="col d-flex justify-content-between">
				<button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
				</button>
				<button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
				</button>
			</div>
		</div>
	</form>
	<div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
			<h3 class="mt-2">Vă rugăm așteptați!</h3>
		</div>
	</div>
</div>